import React, { useState, useEffect } from 'react';

const CONSENT_KEY = 's2t_analytics_consent';

/**
 * Returns the current consent state from localStorage.
 * 'granted' | 'denied' | null (not yet decided)
 */
export function getAnalyticsConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

/**
 * Lightweight POPIA / GDPR-compatible analytics consent banner.
 * Renders at the bottom of the viewport until the user accepts or declines.
 */
const CookieConsent = ({ onConsentChange }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getAnalyticsConsent();
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    try { localStorage.setItem(CONSENT_KEY, 'granted'); } catch {}
    setVisible(false);
    if (onConsentChange) onConsentChange('granted');
  };

  const handleDecline = () => {
    try { localStorage.setItem(CONSENT_KEY, 'denied'); } catch {}
    setVisible(false);
    if (onConsentChange) onConsentChange('denied');
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[9999] px-4 pb-4 pointer-events-none">
      <div className="max-w-lg mx-auto pointer-events-auto bg-white border border-gray-200 rounded-xl shadow-lg p-4 sm:p-5">
        <p className="text-sm text-gray-600 leading-relaxed">
          We use analytics cookies to understand how you use Share2Teach so we can improve the experience.
          No personal data is sold or shared with third parties.
        </p>
        <div className="flex items-center gap-3 mt-3">
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 rounded-lg transition-colors"
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
